// Website Hub sample data shared by more than one page (no hub API exists yet)

// unread contact-form messages: the Contact Forms tab badge, the Overview attention row and the Contact forms stat
export const NEW_MESSAGES = 3;

// the six Website content libraries: the cards on Website content and the "What's on the website" list on Overview
export interface ContentSection {
    slug: string;
    title: string;
    // card subtitle on Website content
    summary: string;
    // the shorter line on Overview
    overviewLine: string;
    overviewTitle?: string;
    updated: string;
    updatedBy: string;
    // updated by Investi itself (capital structure figures arrive from the registry and the ASX)
    automatic?: boolean;
    // where it shows on the website
    path: string;
}

export const CONTENT_SECTIONS: ContentSection[] = [
    { slug: 'news-media', title: 'News & media', summary: '24 items · articles, videos, podcasts, webinars', overviewLine: '24 articles · updated 2 Sep', updated: '2 September 2026, 4:12 pm AWST', updatedBy: 'Wallace Turner', path: '/news-media/' },
    { slug: 'board-management', title: 'Board & management', summary: '6 people', overviewLine: '6 people · updated 14 Jul', updated: '14 July 2026, 10:35 am AWST', updatedBy: 'Lily Ferliansyah', path: '/about-us/board-management/' },
    { slug: 'corporate-governance', title: 'Corporate governance', summary: '12 documents', overviewLine: '12 documents · updated 30 Jun', updated: '30 June 2026, 9:02 am AWST', updatedBy: 'Wallace Turner', path: '/about-us/corporate-governance/' },
    { slug: 'other-documents', title: 'Other documents', overviewTitle: 'Other documents (ESG)', summary: '9 files in 3 folders (ESG, Community, Approvals)', overviewLine: '9 files in 3 folders · updated 21 Aug', updated: '28 August 2026, 2:47 pm AWST', updatedBy: 'Sam Taylor', path: '/investors/other-documents/' },
    { slug: 'company-details', title: 'Company details', summary: 'Address, phone, email, ABN, registry', overviewLine: 'Address, phone, email · updated 3 Mar', updated: '12 August 2026, 11:20 am AWST', updatedBy: 'Wallace Turner', path: '/investors/corporate-directory/' },
    { slug: 'capital-structure', title: 'Capital structure', summary: 'Shares, options, performance rights, market cap', overviewLine: 'Updated 12 Aug · shares on issue 128.4M', updated: '3 September 2026, 8:15 am AWST', updatedBy: 'Investi, automatically', automatic: true, path: '/investors/investors-dashboard/' },
];
